module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-sybilla.69455349.jpg";